import { usesIdentifier } from '@cli-utils/text.js'

export function filterNamedImportsByUsage(importDeclarations: string[], source: string): string[] {
  return importDeclarations.flatMap((declaration) => {
    const match = declaration.match(/^import\s+\{\s*([\s\S]*?)\s*\}\s+from\s+(.+)$/)
    if (!match) return [declaration]

    const importedNames = match[1]
      .split(',')
      .map((name) => name.trim())
      .filter(Boolean)
    const usedNames = importedNames.filter((name) => usesIdentifier(source, name))
    if (usedNames.length === 0) return []
    if (usedNames.length === importedNames.length) return [declaration]
    return [`import { ${usedNames.join(', ')} } from ${match[2]}`]
  })
}
